import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as c } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const t = c((l, s) => /* @__PURE__ */ o.jsx(
  r,
  {
    ref: s,
    ...l,
    image: (a) => /* @__PURE__ */ o.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M18.54 31.47c-.22 0-.43-.09-.58-.27a.76.76 0 0 1 .1-1.06l2.8-2.32a.75.75 0 0 1 1.23.58v.66l1.41-1.23a.745.745 0 0 1 1.24.56v.72l1.57-1.3a.75.75 0 0 1 1.23.58v.66l1.41-1.23c.31-.27.79-.24 1.06.07s.24.79-.07 1.06l-2.65 2.32c-.22.2-.54.24-.8.12a.75.75 0 0 1-.44-.68V30l-1.57 1.3a.75.75 0 0 1-1.23-.58v-.66l-1.41 1.23a.745.745 0 0 1-1.24-.56V30l-1.57 1.3c-.15.11-.32.17-.49.17M35.31 23.88c-2.67 0-4.69-2-4.69-4.65 0-1.92 1.18-3.46 2.14-4.69 1.78-2.31 1.81-5.76 1.81-5.79 0-.41.33-.74.74-.75.43.01.75.32.76.73 0 .04.14 3.72 1.71 5.82.15.2.31.4.47.6.81 1.04 1.75 2.23 1.75 3.93 0 2.87-1.89 4.8-4.69 4.8m-.01-10.97c-.3.85-.72 1.72-1.31 2.49-.94 1.22-1.87 2.42-1.87 3.84 0 1.82 1.34 3.15 3.19 3.15 1.97 0 3.19-1.27 3.19-3.3 0-1.18-.67-2.02-1.45-3a27 27 0 0 1-.49-.63c-.56-.77-.96-1.66-1.26-2.55"
            }
          ),
          /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M23.99 40C15.17 40 8 32.82 8 24S15.17 8 23.99 8c2.89 0 5.72.78 8.19 2.26.36.21.47.67.26 1.03s-.67.47-1.03.26c-2.23-1.34-4.8-2.04-7.42-2.04C16 9.5 9.5 16 9.5 24S16 38.5 23.99 38.5c7.54 0 13.75-5.66 14.43-13.17.04-.41.4-.71.81-.68.41.04.72.4.68.81C39.16 33.75 32.32 40 23.99 40"
            }
          )
        ]
      }
    )
  }
));
t.displayName = "AgencyAnxiousIcon";
export {
  t as AgencyAnxiousIcon,
  t as default
};
//# sourceMappingURL=index.js.map
